import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ea0417a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "py-[74px]" }
const _hoisted_2 = { class: "pl-[45px]" }
const _hoisted_3 = { class: "flex flex-col gap-y-4" }
const _hoisted_4 = { class: "flex flex-col gap-y-4" }
const _hoisted_5 = { class: "pl-4" }
const _hoisted_6 = { class: "pl-8" }
const _hoisted_7 = { class: "flex items-center justify-center mb-[40px]" }
const _hoisted_8 = {
  key: 0,
  class: "show fixed bg-[var(--bg-color)] inset-0 overflow-scroll z-50"
}

import BaseTypography from '@/components/common/BaseTypography.vue';
import BaseButton from '@/components/common/BaseButton.vue';
import Form from '@/components/Index/Form.vue';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'FirstSection',
  setup(__props) {

const { t } = useI18n();

const toggle = ref<boolean>(false);

const toggleForm = () => (toggle.value = !toggle.value);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(BaseTypography, {
            text: _unref(t)('main-page.subtitle'),
            type: "title2-m",
            color: "var(--base-white)"
          }, null, 8, ["text"]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", null, [
              _createVNode(BaseTypography, {
                text: _unref(t)('main-page.tagline.text-1.first'),
                type: "headline-m",
                tag: "span",
                color: "var(--primary-color)"
              }, null, 8, ["text"]),
              _createVNode(BaseTypography, {
                text: _unref(t)('main-page.tagline.text-1.second'),
                type: "headline2-m",
                tag: "span",
                color: "var(--base-white)"
              }, null, 8, ["text"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(BaseTypography, {
                text: _unref(t)('main-page.tagline.text-2.first'),
                type: "headline-m",
                tag: "span",
                color: "var(--primary-color)"
              }, null, 8, ["text"]),
              _createVNode(BaseTypography, {
                text: _unref(t)('main-page.tagline.text-2.second'),
                type: "headline2-m",
                tag: "span",
                color: "var(--base-white)"
              }, null, 8, ["text"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(BaseTypography, {
                text: _unref(t)('main-page.tagline.text-3.first'),
                type: "headline-m",
                tag: "span",
                color: "var(--primary-color)"
              }, null, 8, ["text"]),
              _createVNode(BaseTypography, {
                text: _unref(t)('main-page.tagline.text-3.second'),
                type: "headline2-m",
                tag: "span",
                color: "var(--base-white)"
              }, null, 8, ["text"])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(BaseButton, {
        text: _unref(t)('main-page.submit'),
        type: "subtitle4-m",
        ui: "primary-with-back",
        color: "var(--base-white)",
        onClick: toggleForm
      }, null, 8, ["text"])
    ]),
    (toggle.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(Form, { onClose: toggleForm })
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})